import { render, staticRenderFns } from "./weekPlanMobile.vue?vue&type=template&id=48d66f14&scoped=true"
import script from "./weekPlanMobile.vue?vue&type=script&lang=js"
export * from "./weekPlanMobile.vue?vue&type=script&lang=js"
import style0 from "./weekPlanMobile.vue?vue&type=style&index=0&id=48d66f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d66f14",
  null
  
)

export default component.exports